export const MANDANT_CONFIG_DATA = 'MandantConfig/data';
export const MANDANT_CONFIG_TRANSLATION = 'MandantConfig/translation';
export const MANDANT_CONFIG_LOADING = 'MandantConfig/loading';
export const MANDANT_CONFIG_LOGO_FOUND = 'MandantConfig/logoFound';

export const setLoading = (
  loading: boolean,
): { type: typeof MANDANT_CONFIG_LOADING; payload: { loading: boolean } } => ({
  type: MANDANT_CONFIG_LOADING,
  payload: { loading },
});

export const setData = (
  data: unknown,
): { type: typeof MANDANT_CONFIG_DATA; payload: { data: any } } => ({
  type: MANDANT_CONFIG_DATA,
  payload: { data },
});

export const setLogoFound = (
  logoFound: boolean,
): { type: typeof MANDANT_CONFIG_LOGO_FOUND; payload: { logoFound: boolean } } => ({
  type: MANDANT_CONFIG_LOGO_FOUND,
  payload: { logoFound },
});

export const setTranslation = (
  data: any[],
): { type: typeof MANDANT_CONFIG_TRANSLATION; payload: any[] } => ({
  type: MANDANT_CONFIG_TRANSLATION,
  payload: data,
});
